new MutationObserver(() => {
    fixAccessibility();
}).observe(document.body, { childList: true, subtree: true });

const fixAccessibility = () => {
    document.querySelectorAll('img').forEach(el => {
        if (!el.hasAttribute('alt')) {
            el.setAttribute('alt', '')
        }
    })
}

fixAccessibility();

new MutationObserver(() => {
    document.querySelectorAll('[aria-hidden="true"]').forEach(hiddenElement => {
        hiddenElement.querySelectorAll('a, button, input, select, textarea').forEach(focusable => {
            focusable.setAttribute('tabindex', '-1');
        });
    });

    document.querySelectorAll('[aria-hidden="false"]').forEach(visibleElement => {
        visibleElement.querySelectorAll('[tabindex="-1"]').forEach(focusable => {
            focusable.removeAttribute('tabindex');
        });
    });
}).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
